<div class="header">
  <h3>Admin</h3>
</div>
<div class="row">
  <div class="col tab-menu">
    <admin-nav-menu [currentTab]="'topics-and-standards'"></admin-nav-menu>
  </div>

  <div class="col col-constrained">
    <fieldset>
      <legend>Topic</legend>

      <div class="d-flex justify-content-end align-items-center mb-2">
        <button type="button" class="btn btn-sm btn-primary text-nowrap" (click)="openNewTopic()">
          <i class="fa fa-plus"></i>
          New Topic
        </button>
      </div>

      <grid-pager [actionName]="'/admin/topics-and-standards'" [page]="page" [limit]="limit" [pageCount]="topicPageCount" [limits]="pageLimitOptions"></grid-pager>

      <table class="table table-sm table-align-middle">
        <thead>
          <tr class="headers-row">
            <th style="width: 4rem;"></th>
            <th>Topic</th>
            <th>Last Modified Date</th>
            <th>Last Modified By</th>
            <th>Active</th>
          </tr>
          <tr class="filters-row">
            <td>
              <button type="button" class="btn btn-sm btn-block btn-secondary text-nowrap" (click)="clearTopicFilters()">
                <i class="fa fa-times"></i>
                Clear
              </button>
            </td>
            <td>
              <input
                type="text"
                class="form-control form-control-sm"
                placeholder="Filter by..."
                [(ngModel)]="topicNameFilter"
                (change)="updateDataGrid()" />
            </td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          @if (topics.length == 0) {
            <tr>
              <td colspan="5">
                <span class="d-block p-2 text-center">
                  <i class="fa fa-ban text-danger"></i>
                  No data to display&hellip;
                </span>
              </td>
            </tr>
          }
          @for (topic of topics; track topic) {
            <tr>
              <td>
                <button type="button" class="btn btn-sm btn-secondary" title="Edit topic" (click)="openEditTopic(topic)">
                  <i class="fa fa-edit"></i>
                  Edit
                </button>
              </td>
              <td>{{topic.name}}</td>
              <td>{{getTopicLastModifiedDate(topic) | date : 'shortDate'}}</td>
              <td>{{getTopicLastModifiedBy(topic)}}</td>
              <td>{{topic.isActive}}</td>
            </tr>
          }
        </tbody>
      </table>

      <grid-pager [actionName]="'/admin/topics-and-standards'" [page]="page" [limit]="limit" [pageCount]="topicPageCount" [limits]="pageLimitOptions"></grid-pager>
    </fieldset>

    <hr class="my-4" />

    <fieldset>
      <legend>Standard</legend>

      <div class="d-flex justify-content-end align-items-center mb-2">
        <button type="button" class="btn btn-sm btn-primary text-nowrap" (click)="openNewStandard()">
          <i class="fa fa-plus"></i>
          New Standard
        </button>
      </div>

      <grid-pager [actionName]="'/admin/topics-and-standards'" [page]="page" [limit]="limit" [pageCount]="standardPageCount" [limits]="pageLimitOptions"></grid-pager>

      <table class="table table-sm table-align-middle">
        <thead>
          <tr class="headers-row">
            <th style="width: 4rem;"></th>
            <th>Standard</th>
            <th>Last Modified Date</th>
            <th>Last Modified By</th>
            <th>Active</th>
          </tr>
          <tr class="filters-row">
            <td>
              <button type="button" class="btn btn-sm btn-block btn-secondary text-nowrap" (click)="clearStandardFilters()">
                <i class="fa fa-times"></i>
                Clear
              </button>
            </td>
            <td>
              <input
                type="text"
                class="form-control form-control-sm"
                placeholder="Filter by..."
                [(ngModel)]="standardNameFilter"
                (change)="updateDataGrid()" />
            </td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          @if (standards.length == 0) {
            <tr>
              <td colspan="5">
                <span class="d-block p-2 text-center">
                  <i class="fa fa-ban text-danger"></i>
                  No data to display&hellip;
                </span>
              </td>
            </tr>
          }
          @for (standard of standards; track standard) {
            <tr>
              <td>
                <button type="button" class="btn btn-sm btn-secondary" title="Edit standard" (click)="openEditStandard(standard)">
                  <i class="fa fa-edit"></i>
                  Edit
                </button>
              </td>
              <td>{{standard.name}}</td>
              <td>{{getStandardLastModifiedDate(standard) | date : 'shortDate'}}</td>
              <td>{{getStandardLastModifiedBy(standard)}}</td>
              <td>{{standard.isActive}}</td>
            </tr>
          }
        </tbody>
      </table>

      <grid-pager [actionName]="'/admin/topics-and-standards'" [page]="page" [limit]="limit" [pageCount]="standardPageCount" [limits]="pageLimitOptions"></grid-pager>
    </fieldset>
  </div>
</div>

<ng-template #newTopicModal let-modal>
  <form #newTopicForm="ngForm" (ngSubmit)="createTopic(modal)">
    <div class="modal-header">
      <h5 class="modal-title" id="new-topic-modal-title">{{editingTopic ? 'Edit Topic' : 'New Topic'}}</h5>
      <button type="button" class="close" aria-label="Close" [disabled]="isSavingTopic" (click)="cancelTopic(modal)">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label for="new-topic-name">Name</label>
        <input
          type="text"
          id="new-topic-name"
          name="newTopicName"
          class="form-control"
          aria-describedby="new-topic-name-validation"
          [(ngModel)]="newTopicName"
          (ngModelChange)="onTopicNameChanged()"
          [disabled]="isSavingTopic"
          maxlength="200"
          pattern=".*\S.*"
          required />
        <small id="new-topic-name-validation" class="form-text validation-message">Name is required and cannot exceed 200 characters.</small>
        @if (topicNameDuplicate) {
          <small class="form-text text-danger">A non-deleted Topic with this name already exists.</small>
        }
      </div>
      <div class="form-check">
        <input type="checkbox" id="topic-is-active" name="topicIsActive" class="form-check-input" [(ngModel)]="topicIsActive" [disabled]="isSavingTopic" />
        <label class="form-check-label" for="topic-is-active">Active</label>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" [disabled]="isSavingTopic" (click)="cancelTopic(modal)">Cancel</button>
      <button type="submit" class="btn btn-primary" [disabled]="newTopicForm.invalid || topicNameDuplicate || isSavingTopic">
        <i class="fa fa-save"></i>
        Save
      </button>
    </div>
  </form>
</ng-template>

<ng-template #newStandardModal let-modal>
  <form #newStandardForm="ngForm" (ngSubmit)="createStandard(modal)">
    <div class="modal-header">
      <h5 class="modal-title" id="new-standard-modal-title">{{editingStandard ? 'Edit Standard' : 'New Standard'}}</h5>
      <button type="button" class="close" aria-label="Close" [disabled]="isSavingStandard" (click)="cancelStandard(modal)">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label for="new-standard-name">Name</label>
        <input
          type="text"
          id="new-standard-name"
          name="newStandardName"
          class="form-control"
          aria-describedby="new-standard-name-validation"
          [(ngModel)]="newStandardName"
          (ngModelChange)="onStandardNameChanged()"
          [disabled]="isSavingStandard"
          maxlength="200"
          pattern=".*\S.*"
          required />
        <small id="new-standard-name-validation" class="form-text validation-message">Name is required and cannot exceed 200 characters.</small>
        @if (standardNameDuplicate) {
          <small class="form-text text-danger">A non-deleted Standard with this name already exists.</small>
        }
      </div>
      <div class="form-check">
        <input type="checkbox" id="standard-is-active" name="standardIsActive" class="form-check-input" [(ngModel)]="standardIsActive" [disabled]="isSavingStandard" />
        <label class="form-check-label" for="standard-is-active">Active</label>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" [disabled]="isSavingStandard" (click)="cancelStandard(modal)">Cancel</button>
      <button type="submit" class="btn btn-primary" [disabled]="newStandardForm.invalid || standardNameDuplicate || isSavingStandard">
        <i class="fa fa-save"></i>
        Save
      </button>
    </div>
  </form>
</ng-template>
